import { Node } from '@xyflow/react';

// Added support for new no-title edge types
export const useNodeConnect = (setNodes: any, setEdges: any, setStepTypeMap: any, setSelectedNode: any, setDrawerOpen: any) => {
  const addNodeAndConnect = (sourceId: string, handleId: 'onCompleteStep' | 'onFailedStep' | 'noTitleEdge1' | 'noTitleEdge2', stepType: string, step: any) => {
    let offsetX = 200;
    let offsetY = 100;
      // Different positioning for different edge types
    if (handleId === 'noTitleEdge1') {
      // Top edge - position above the source node
      offsetX = 0;
      offsetY = -180;
    } else if (handleId === 'noTitleEdge2') {
      // Left edge - position to the left of the source node
      offsetX = -220;
      offsetY = 0;
    } else if (handleId === 'onCompleteStep') {
      // Right edge - position to the right (default)
      offsetX = 200;
      offsetY = 0;
    } else if (handleId === 'onFailedStep') {
      // Bottom edge - position below
      offsetX = 0;
      offsetY = 150;
    }

    setNodes((nds: any) => {
      const sourceNode = nds.find((n: Node) => n.id === sourceId);

      const position = sourceNode
        ? {
            x: sourceNode.position.x + offsetX,
            y: sourceNode.position.y + offsetY
          }
        : { x: 100, y: 100 };

      let nodeConfig = {
        id: step.uid,
        position,
        measured: { height: 100, width: 100 },
        type: 'custom'
      };

      const newNode: Node = {
        ...nodeConfig,
        data: {
          id: step.uid,
          label: step.title,
          onClick: () => {
            setSelectedNode({
              ...nodeConfig,
              data: {
                id: step.uid,
                label: step.title,
                onClick: () => {},
                addNodeAndConnect,
                step,
                component: step.component
              }
            });
            setDrawerOpen(true);
          },
          addNodeAndConnect,
          step,
          component: step.component
        }
      };

      // Added support for new no-title edge types with gray color and no labels
      setEdges((eds: any) => [
        ...eds,
        {
          id: `e-${sourceId}-${step.uid}`,
          source: sourceId,
          target: step.uid,
          type: handleId,
          sourceHandle: handleId,
          label: handleId === 'onCompleteStep' ? 'Success' : 
                 handleId === 'onFailedStep' ? 'Failure' : '',
          animated: true,
          style: { 
            stroke: handleId === 'noTitleEdge1' || handleId === 'noTitleEdge2' ? '#808080' : 'green' 
          }
        }
      ]);

      setStepTypeMap((prev: any) => ({
        ...prev,
        [step.uid]: stepType
      }));

      return [...nds, newNode];
    });
  };

  return addNodeAndConnect;
};
